import './styles.scss';
import React, {Dispatch} from 'react'
import {NavLink} from "react-router-dom";

/* Types, Constants, Utils */
import * as Constants from "../../../../../constants";
import SearchUtils from "../../../../../utils/search-utils";
import {TQueryItem} from "../../../../../constants";

/* Redux */
import {setContentCategory} from "../../../../../redux/slices/content-slice";
import {AnyAction} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";
import {setDBSet, setQuery} from "../../../../../redux/slices/search-slice";

/* Components */
import {CMSLinkType} from "../Link";
import {Media} from "../Media";
import LinkButton from "../../../../../components/button-link";
import useCardLink, {IUseCardLink} from "../ContentGrid/useCardLink";

export const Card: React.FC<
  {
    type: string,
    media?: any,
    title?: string,
    description?: string,
    enablelink?: boolean,
    link?: CMSLinkType,
    greybackground?: boolean
  }
> = props => {
  const {
    type,
    media,
    title,
    description,
    //enablelink,
    link,
    greybackground
  } = props

  const dispatch:Dispatch<AnyAction> = useDispatch();
  const {getURL}: IUseCardLink = useCardLink();
  const href: string = getURL(link);

  if (link) {
    const nav = ()=>{
      dispatch(setContentCategory(null));
      const urlSegments: string[] = href.split('/');
      if ((urlSegments[2] === Constants.BIBLIOGRAPHY) || (urlSegments[2] === Constants.DOCUMENTS)) {
        dispatch(setDBSet(urlSegments[2]))
      }
      const paramsSplit: string[] = href.split('?');
      if (paramsSplit.length > 1) {
        const searchParams: URLSearchParams = new URLSearchParams(paramsSplit[1]);
        const query: TQueryItem[] = SearchUtils.convertQueryParams(searchParams.get(Constants.QUERY_KEY).toString());
        dispatch(setQuery({
          query: query,
          recent_query: false
        }));
      }

      setTimeout(()=>{
        window.location.href = href
      })
    }

    if (type === Constants.MENU) {
      return (
        <NavLink
          className={'content-card card has-link' + (greybackground ? ' grey-background' : '')}
          to={href}
          onClick={()=>{}}
        >
          <div className={'pt-3 px-3 pb-5 mb-3'}>
            {title && <h5 className={'max-lines lines-4'}><strong>{title}</strong></h5>}
            {description && <p className={'description m-0'}>{description}</p>}
          </div>
        </NavLink>
      )
    } else {
      return (
        <div
          className={'content-card card has-link' + (greybackground ? ' grey-background' : '')}
        >
          {media &&
            <div className={'d-flex justify-content-center'}>
              <div className={'img-container border'}>
                <Media resource={media}/>
              </div>
            </div>
          }

          <div className={'pt-3 px-3 pb-5 mb-3'}>
            {title && <h5 className={'max-lines lines-4'}><strong>{title}</strong></h5>}
            {description && <p className={'description m-0'}>{description}</p>}
            <div className={'link-container position-absolute'}>
              <LinkButton
                label={link.label}
                clickFunc={nav}
                linkArrow={true}
                underline={true}
                disabled={false}
              />
            </div>
          </div>
        </div>
      )
    }
    //return <div className={'content-card card'}><CMSLink {...link} /></div>
  } else {
    return <div className={'content-card card' + (greybackground ? ' grey-background' : '')}>
      {media &&
        <div className={'d-flex justify-content-center mt-1'}>
          <div className={'img-container border'}>
            <Media resource={media}/>
          </div>
        </div>
      }

      <div className={'py-3 px-3'}>
        {title && <h5 className={'max-lines lines-4'}>{title}</h5>}
        {description && <p className={'description m-0'}>{description}</p>}
      </div>
    </div>
  }
}
